import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import constants from '../../config/constants';
import { getQtyMapFromStorage } from '../../utils/cart/qty-hook';
import _ from '../../utils/LodashImports';
import BodyCopy from '../ui/BodyCopy/BodyCopy';
import ShippingDetailsStyles from './ShippingDetails.style';

const { LAYOUT_1_GRID, LAYOUT_LIST } = constants;

const isNonEmptyString = (str) => {
  return typeof str === 'string' && str.trim().length > 0;
};

const ShippingDetails = ({ availability, labels, layout, isTottusSA, variant, expressDeliveryLimit, appCtx }) => {
  const useLocalStorageForQtyLimits = _.get(appCtx, 'siteConfig.toggles.useLocalStorageForQtyLimits', false);
  const [quantitiesMap, setQuantitiesMap] = useState(new Map());

  useEffect(() => {
    setQuantitiesMap(getQtyMapFromStorage(useLocalStorageForQtyLimits));
  }, [useLocalStorageForQtyLimits]);

  const qty = quantitiesMap.get(variant)?.quantity ?? 0;
  const { primeShipping, internationalShipping } = availability;
  let { pickUpFromStoreShipping, homeDeliveryShipping, expressShipping } = availability;
  const getRebrandingSuccessIcon = () => {
    if (layout === LAYOUT_LIST) {
      return 'rebranding-sucess-icon-list';
    }
    if (layout === LAYOUT_1_GRID) {
      return 'rebranding-sucess-icon-grid';
    }
    return 'rebranding-sucess-icon';
  };
  if (isTottusSA && expressDeliveryLimit > 0) {
    if (
      qty > expressDeliveryLimit &&
      (isNonEmptyString(homeDeliveryShipping) || isNonEmptyString(pickUpFromStoreShipping))
    ) {
      expressShipping = '';
    } else {
      homeDeliveryShipping = '';
      pickUpFromStoreShipping = '';
    }
  }
  return (
    <ul className="shipping-details">
      {primeShipping && (
        <li>
          <i className={`icon boomIcon icon-${layout}`}>
            <span className="sr-only">{labels.POD_BOOM_SHIPPING_LABEL}</span>
          </i>
        </li>
      )}
      {internationalShipping && (
        <li className="international-shipping-wrapper">
          <span className="aeroplane-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{internationalShipping}</span>}</BodyCopy>
        </li>
      )}
      {expressShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="express-icon" />
            <BodyCopy size="copy4">
              {(cl) => <span dangerouslySetInnerHTML={{ __html: expressShipping }} className={`${cl}`} />}
            </BodyCopy>
          </div>
        </li>
      )}
      {homeDeliveryShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="scheduled-icon" />
            <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{homeDeliveryShipping}</span>}</BodyCopy>
          </div>
        </li>
      )}
      {pickUpFromStoreShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="store-icon" />
            <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{pickUpFromStoreShipping}</span>}</BodyCopy>
          </div>
        </li>
      )}
      <style jsx>{ShippingDetailsStyles}</style>
    </ul>
  );
};

ShippingDetails.defaultProps = {
  layout: '4_GRID',
  isTottusSA: false,
  variant: '',
  expressDeliveryLimit: 0,
  appCtx: {},
};

ShippingDetails.propTypes = {
  availability: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  layout: PropTypes.string,
  isTottusSA: PropTypes.bool,
  variant: PropTypes.string,
  expressDeliveryLimit: PropTypes.number,
  appCtx: PropTypes.object,
};

export { isNonEmptyString, ShippingDetails };
